import {
  processWizardTranslation,
  ProcessWizardTranslation,
} from '@/assets/locales/views/emails/threadEmails/processWizard.translation.pl.ts';

export type DeleteEmailDialogTranslation = {
  button: {
    cancel: string;
    ok: string;
  };
  content: string;
  title: string;
};

export const deleteEmailDialogTranslation: DeleteEmailDialogTranslation = {
  button: {
    cancel: 'Anuluj',
    ok: 'Usuń',
  },
  content: 'Czy na pewno chcesz usunąć wiadomość od ',
  title: 'Usuń email',
};

export type ThreadEmailsTranslation = {
  dialog: {
    attachToExistingProcess: {
      button: {
        cancel: string;
        save: string;
      };
      form: {
        process: string;
      };
      title: string;
      tooltip: {
        addToProcess: string;
        goToProcess: string;
      };
    };
    attachToExistingTask: {
      button: {
        cancel: string;
        save: string;
      };
      form: {
        process: string;
      };
      title: string;
      tooltip: {
        addToTask: string;
        goToTask: string;
      };
    };
    deleteEmail: DeleteEmailDialogTranslation;
    newProcess: {
      button: {
        cancel: string;
        chooseOtherData: string;
        createProcess: string;
        start: string;
      };
      form: {
        employee: string;
        forWhom: string;
        processName: string;
      };
      forMe: string;
      forOther: string;
      matchContact: string;
      matchEmail: string;
      matchOwner: string;
      processOwner: string;
      selectMatch: string;
      title: string;
    };
    processWizard: ProcessWizardTranslation;
  };
  email: {
    body: {
      hideHistory: string;
      showHistory: string;
    };
    summary: {
      button: {
        copy: string;
        copySubject: string;
      };
      cc: string;
      draft: string;
      editDraft: string;
      emailCopiedConfirmation: string;
      subject: string;
      subjectCopiedConfirmation: string;
      subjectCopyFailed: string;
      to: string;
    };
  };
  header: {
    button: {
      goToProcess: string;
      goToTask: string;
    };
    toProcess: ToResourceTranslation;
    toTask: ToResourceTranslation;
  };
  noEmailSelected: string;
};

type ToResourceTranslation = {
  button: {
    attachToExisting: string;
    openMenu: string;
    startNew: string;
  };
};

export const threadEmailsTranslation: ThreadEmailsTranslation = {
  dialog: {
    attachToExistingProcess: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      form: {
        process: 'Wybierz process',
      },
      title: 'Dołączanie wiadomości do istniejącego procesu',
      tooltip: {
        addToProcess: 'Dodaj do istniejącego procesu',
        goToProcess: 'Przejdź do procesu',
      },
    },
    attachToExistingTask: {
      button: {
        cancel: 'Anuluj',
        save: 'Zapisz',
      },
      form: {
        process: 'Wybierz zadanie',
      },
      title: 'Dołączanie wiadomości do istniejącego zadania',
      tooltip: {
        addToTask: 'Dodaj do istniejącego zadania',
        goToTask: 'Przejdź do zadania',
      },
    },
    deleteEmail: deleteEmailDialogTranslation,
    newProcess: {
      button: {
        cancel: 'Anuluj',
        chooseOtherData: 'Samodzielnie wybierz dane',
        createProcess: 'Rozpocznij proces z powyższymi danymi',
        start: 'Rozpocznij',
      },
      form: {
        employee: 'Wybierz pracownika',
        forWhom: 'Dla kogo',
        processName: 'Nazwa procesu',
      },
      forMe: 'Dla mnie',
      forOther: 'Dla innego pracownika',
      matchContact: 'Kontakt',
      matchEmail: 'Email',
      matchOwner: 'Opiekun',
      processOwner: 'Właściciel procesu',
      selectMatch: 'Wybierz dopasowanie',
      title: 'Rozpoczynanie nowego procesu sprzedażowego',
    },
    processWizard: processWizardTranslation,
  },
  email: {
    body: {
      hideHistory: 'Ukryj historię wiadomości',
      showHistory: 'Pokaż historię wiadomości',
    },
    summary: {
      button: {
        copy: 'Kopiuj',
        copySubject: 'Kopiuj temat',
      },
      cc: 'Kopia',
      draft: 'Szkic',
      editDraft: 'Szkic',
      emailCopiedConfirmation: 'Adres skopiowany do schowka',
      subject: 'Temat',
      subjectCopiedConfirmation: 'Temat skopiowany do schowka',
      subjectCopyFailed: 'Nie udało się skopiować tematu do schowka',
      to: 'Do',
    },
  },
  header: {
    button: {
      goToProcess: 'Przejdź do procesu',
      goToTask: 'Przejdź do zadania',
    },
    toProcess: {
      button: {
        attachToExisting: 'Do istniejącego',
        openMenu: 'Dodaj do procesu',
        startNew: 'Do nowego',
      },
    },
    toTask: {
      button: {
        attachToExisting: 'Do istniejącego',
        openMenu: 'Dodaj do zadania',
        startNew: 'Do nowego',
      },
    },
  },
  noEmailSelected: 'Wybierz wątek lub wiadomość do przeczytania',
};
